export default "__VITE_ASSET__BdQ8HdWH__"